import React from 'react';
import { SETTING, SettingValueType } from 'interfaces/settings';
import { Typography } from 'interfaces/typography';
import { Settings } from 'lucide-react';
import { SelectionType } from "interfaces/settings";
import { useAutodialerSettings } from '../hooks/useAutodialerSettings';

interface NotSetSettingProps {
    setting: SETTING;
    isInMultiRow?: boolean;
}

export function NotSetSetting({ setting, isInMultiRow = false }: NotSetSettingProps) {
    const { updateSetting, getDefaultValueForSetting, selection, formatSettingValue } = useAutodialerSettings();

    const defaultValue: SettingValueType<SETTING> | null = getDefaultValueForSetting(setting);
    const handleSetDefault = () => updateSetting(setting, defaultValue)
   
    const isPersonalSetting = selection?.type === SelectionType.ME

    const actionText = isPersonalSetting ? 'Click to set' : 'Click to lock';

    // Compact version for multi-row
    if (isInMultiRow) {
        return (
            <div className="flex-1 min-w-0">
                <button
                    onClick={handleSetDefault}
                    className="w-full h-8 flex flex-col items-center justify-center px-2 py-1 bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 rounded border border-blue-200 hover:border-blue-300 transition-all duration-200 shadow-sm hover:shadow-md group"
                    title={`${actionText} default: ${formatSettingValue(setting, defaultValue) || 'None'}`}
                >
                    <Typography variant="smallParagraph" color="#1e40af" fontWeight="600" className="text-center leading-tight">
                        {formatSettingValue(setting, defaultValue) || 'None'}
                    </Typography>
                    <Typography variant="smallParagraph" color="#6b7280" fontWeight="400" className="text-center text-xs leading-tight">
                        {actionText}
                    </Typography>
                </button>
            </div>
        );
    }

    return (
        <div className="flex-1 min-w-0">
            <button
                onClick={handleSetDefault}
                className="w-full h-8 flex items-center gap-3 px-3 py-1 bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 rounded border border-blue-200 hover:border-blue-300 transition-all duration-200 shadow-sm hover:shadow-md group"
            >
                <Settings size={14} className="text-blue-500 group-hover:text-blue-600 flex-shrink-0" />
                <div className="flex-1 flex items-center justify-between min-w-0 gap-3">
                    <Typography variant="smallParagraph" color="#1e40af" fontWeight="600" className="flex-1 text-left">
                        Default: {formatSettingValue(setting, defaultValue) || 'None'}
                    </Typography>
                    <Typography variant="smallParagraph" color="#6b7280" fontWeight="500" className="flex-shrink-0">
                        {actionText}
                    </Typography>
                </div>
            </button>
        </div>
    );
} 